import React, { Component } from "react";
import {
  DropdownItem,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  Button,
  Input,
} from "reactstrap";
import { QuoteStatus, QuoteMode } from "../../../utils/Quote/Quote";
import style from "../Quotebar.module.scss";
import { Mode, TimeFrame, OrderPriceType, Type, CommissionType } from "../../../utils/Order/Order";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import { toDateLocal } from "../../../utils/Helper";

class Form extends Component {
  openModalOrder = (type = Type.Default) => {
    const { quote } = this.props;

    const order = {
      AssetClassForm: quote.AssetClassForm,
      AssetTicker: quote.AssetTicker,
      OrderSide: quote.AdvisorQuoteIsBuy ? "Buy" : "Sell",
      OrderPrice: quote.AdvisorQuotePrice,
      OrderQuantity: quote.AdvisorQuoteQuantity,
      OrderType: OrderPriceType.LIMIT,
      quoteId: quote.AdvisorQuoteId,
      OrderInitDate: toDateLocal(new Date()),
      OrderTimeInForce: TimeFrame.GTC,
      OrderGTD: toDateLocal(new Date()),
      CurrentAccount: {
        CommissionType: CommissionType.PrincipalPercentage,
        MarkupType: CommissionType.FaceValueCash,
        FXMarkupType: CommissionType.FaceValueCash,
        CurrentInfoDate: toDateLocal(new Date()),
        Quantity: quote.AdvisorQuoteQuantity,
      },
    };

    this.props.openModalOrder({ mode: Mode.QUOTE, order, type });
  };

  render() {
    const { quote, isTrader, changeMode, changeField, updateQuote, fields } = this.props;
    const { AdvisorQuoteStatus } = quote;

    const mode = quote.mode || QuoteMode.NONE;

    // WAITING / SETTING_PRICE - Trader
    if (AdvisorQuoteStatus == QuoteStatus.WAITING && mode == QuoteMode.SET_PRICE && isTrader) {
      return (
        <div style={{ display: "flex", marginTop: "5px" }}>
          <div style={{ flexGrow: 1, display: "inline-flex" }}>
            <div>
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={fields.AdvisorQuotePrice || ""}
                disabled={false}
                onValueChange={(e) =>
                  changeField(
                    "AdvisorQuotePrice",
                    isNaN(e.floatValue) || e.value.endsWith(".") ? e.value : e.floatValue
                  )
                }
                decimalScale={quote.SubAssetClassDecimalPlaces}
                dataTypeDecimalName="price"
                className={`${style.input} mr-1`}
                placeholder={"Price"}
              />
            </div>
            <div>
              <NumberFormatInput
                customInput={Input}
                type="text"
                className={`${style.input} mr-2`}
                placeholder={"Duration"}
                value={fields.AdvisorQuoteDuration || ""}
                onValueChange={(e) => changeField("AdvisorQuoteDuration", e.value)}
                dataTypeDecimalName="default"
              />
            </div>
          </div>
          <div style={{ color: "black" }}>
            <Button onClick={() => updateQuote()} color="success" size="sm" className="float-right ml-1">
              Accept
            </Button>
            <Button
              onClick={() => changeMode(quote.AdvisorQuoteId, QuoteMode.NONE)}
              color="secondary"
              size="sm"
              className="float-right"
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }
    // WAITING / REJECT - Trader
    // PRICED / REJECT - Advisor
    else if (
      (AdvisorQuoteStatus == QuoteStatus.WAITING && mode == QuoteMode.REJECT) ||
      (AdvisorQuoteStatus == QuoteStatus.PRICED && mode == QuoteMode.REJECT)
    ) {
      return (
        <div>
          <div>
            <div style={{ padding: "5px 0px" }}>
              <Input
                type="textarea"
                value={fields.AdvisorQuoteRejectReason || ""}
                onChange={(e) => changeField("AdvisorQuoteRejectReason", e.target.value)}
                placeholder={"Reason"}
              />
            </div>
          </div>
          <div style={{ height: "25px", textAlign: "right" }}>
            <Button
              onClick={() => changeMode(quote.AdvisorQuoteId, QuoteMode.NONE)}
              color="secondary"
              size="sm"
            >
              Cancel
            </Button>
            <Button onClick={() => updateQuote()} color="success" size="sm" className="ml-1">
              Accept
            </Button>
          </div>
        </div>
      );
    }
    // WAITING / NONE - Trader
    else if (AdvisorQuoteStatus == QuoteStatus.WAITING && mode == QuoteMode.NONE && isTrader) {
      return (
        <div style={{ color: "black", textAlign: "right" }}>
          <Button onClick={() => changeMode(quote.AdvisorQuoteId, QuoteMode.REJECT)} color="danger" size="sm">
            Reject
          </Button>
          <Button
            onClick={() => changeMode(quote.AdvisorQuoteId, QuoteMode.SET_PRICE)}
            color="success"
            size="sm"
            className="ml-1"
          >
            Accept
          </Button>
        </div>
      );
    }
    // PRICED / NONE - Advisor
    else if (AdvisorQuoteStatus == QuoteStatus.PRICED && mode == QuoteMode.NONE && !isTrader) {
      if (quote.expired) {
        return null;
      }

      return (
        <div style={{ color: "black", textAlign: "right" }}>
          <Button onClick={() => changeMode(quote.AdvisorQuoteId, QuoteMode.REJECT)} color="danger" size="sm">
            Reject
          </Button>
          <ButtonGroup className="float-right ml-1">
            <Button color="success" onClick={() => this.openModalOrder()}>
              Move to order
            </Button>

            <UncontrolledDropdown>
              <DropdownToggle direction="down" color="link" size="lg" className={style.moveDropDown}>
                <i className="icon-options-vertical icons d-block"></i>
              </DropdownToggle>

              <DropdownMenu style={{ marginBottom: "5px" }}>
                <DropdownItem onClick={() => this.openModalOrder(Type.Bulk)}>Move to Bulk</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </ButtonGroup>
        </div>
      );
    }
    // NULL
    else {
      return null;
    }
  }
}

export default Form;
